import React from 'react';
import { parseDate } from 'utils/date';
import { splitSsn } from 'utils/strings';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';

export default function CIPRow({ item, categories }) {
  const { t } = useLocale();
  const {
    eventDate,
    firmRegistryLink,
    cipCompanyScoreLink,
    subjectName,
    subjectRegno,
    cipCategoryBefore,
    cipCategoryAfter,
  } = item;

  const business = process.env.REACT_APP_BUSINESS_WEB_URL;
  const firmUrl = `${business}/Search/Search.aspx?${firmRegistryLink}`;
  const cipUrl = `${business}/Reports/CipCompanyScore.aspx?${cipCompanyScoreLink}`;

  const subText =
    cipCategoryAfter === null
      ? t('portfolioMonitoring_cipEvents_base_event')
      : t(`companyCip_score_title_${cipCategoryAfter}`);
  // : categories[cipCategoryAfter];

  const beforeDefault = Number(cipCategoryBefore) > 100;
  const afterDefault = Number(cipCategoryAfter) > 100;
  let arrow = null;
  if (cipCategoryBefore !== null && cipCategoryAfter !== null) {
    arrow = <span className="icon icon-arrow-right half-spacing-left half-spacing-right" />;
    const green =
      Number(cipCategoryBefore) > Number(cipCategoryAfter) ||
      (beforeDefault && cipCategoryAfter <= '10');
    arrow = (
      <span
        className={`icon icon-arrow-right text-${
          green ? 'green' : 'red'
        } half-spacing-left half-spacing-right`}
      />
    );
  }

  const cipBefore = cipCategoryBefore
    ? beforeDefault
      ? `(${categories[cipCategoryBefore]})`
      : `(${cipCategoryBefore})`
    : '';
  const cipAfter = cipCategoryAfter
    ? afterDefault
      ? `(${categories[cipCategoryAfter]})`
      : `(${cipCategoryAfter})`
    : '';

  return (
    <tr>
      <td>{parseDate(eventDate)}</td>
      <td>
        <div>
          <a href={firmUrl} target="_blank" rel="noopener noreferrer">
            {subjectName}
          </a>
        </div>
        <div>{splitSsn(subjectRegno)}</div>
      </td>
      <td>
        <div className="text-bold" style={{ display: 'flex' }}>
          {t('portfolioMonitoring_cipEvents_cat')}: {cipBefore} {arrow} {cipAfter}
        </div>
        <div className="">{subText}</div>
      </td>
      <td>
        <a target="_blank" href={cipUrl} rel="noopener noreferrer">
          {` ${t('portfolioMonitoring_cipEvents_view_cip')} `}
        </a>
      </td>
    </tr>
  );
}
